import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface InvoiceState {
  selectedInvoiceDetailsViewId?: string | null;
}

const initialState: InvoiceState = {
  selectedInvoiceDetailsViewId: null,
};

const invoiceSlice = createSlice({
  name: 'invoices',
  initialState,
  reducers: {
    setSelectedInvoiceDetailsViewId: (state, action: PayloadAction<string | null>) => {
      state.selectedInvoiceDetailsViewId = action.payload;
    },
    clearSelectedInvoiceDetailsViewId: (state) => {
      state.selectedInvoiceDetailsViewId = null;
    },
  },
});

export const {
  setSelectedInvoiceDetailsViewId,
  clearSelectedInvoiceDetailsViewId
} = invoiceSlice.actions;

export default invoiceSlice.reducer;